import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button, InlineNotice, Input } from '@wit-support/ui';
import { CircleAlert } from 'lucide-react';
import { resolvePost } from '../api.js';
import { describeAdsError } from '../shared.js';
/**
 * Поле «Пост»: `pageId_postId`, ссылка facebook.com или голый postId
 * (страница — из профиля кабинета). Каждый пост проверяется через
 * `posts/resolve`; не найден — не добавляется, предупреждения показывает
 * карточка креатива.
 */
export function PostInput({ platformAccountId, onResolved, disabled, }) {
    const [input, setInput] = useState('');
    const [error, setError] = useState(null);
    const resolve = useMutation({
        mutationFn: (value) => resolvePost(platformAccountId, value),
        onSuccess: (post) => {
            if (post.found === 'not_found') {
                setError('Пост не найден ни в индексе, ни в Meta — проверьте ссылку или id');
                return;
            }
            setError(null);
            setInput('');
            onResolved(post);
        },
        onError: (err) => setError(describeAdsError(err, 'write')),
    });
    const submit = () => {
        const v = input.trim();
        if (!v || platformAccountId == null)
            return;
        resolve.mutate(v);
    };
    const off = disabled || platformAccountId == null;
    return (_jsxs("div", { className: "flex flex-col gap-2", children: [_jsxs("div", { className: "flex gap-2", children: [_jsx(Input, { "aria-label": "\u041F\u043E\u0441\u0442: id \u0438\u043B\u0438 \u0441\u0441\u044B\u043B\u043A\u0430", placeholder: "pageId_postId, \u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u043F\u043E\u0441\u0442 \u0438\u043B\u0438 postId", value: input, disabled: off, onChange: (e) => setInput(e.target.value), onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                submit();
                            }
                        } }), _jsx(Button, { type: "button", variant: "secondary", disabled: off || resolve.isPending || input.trim() === '', onClick: submit, children: resolve.isPending ? 'Проверяем…' : 'Добавить' })] }), platformAccountId == null ? (_jsx("span", { className: "text-xs text-[var(--color-text-muted)]", children: "\u0421\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0430\u0431\u0438\u043D\u0435\u0442." })) : null, error ? (_jsx(InlineNotice, { variant: "danger", icon: CircleAlert, as: "div", children: error })) : null] }));
}
//# sourceMappingURL=post-input.js.map